import React from "react"
import { ListGroup, ListGroupItem, Container } from "reactstrap"
import meetingLogo from "../../view/assets/meeting.png"
import groupLogo from "../../view/assets/group.png"
import schoolLogo from "../../view/assets/school.png"
import { Trans, useLingui } from "@lingui/react"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import { setCurrentPage } from "../../store/reducers/navigation"
import styles from "./VslaMenu.module.css"

const VslaMenu = (props) => {
  const { i18n } = useLingui()

  return (
    <Container>
      <ListGroup
        flush
        style={{
          float: i18n.locale === "ar" ? "right" : "none",
        }}
      >
        <ListGroupItem>
          <span
            name="group-details-button"
            onClick={() => props.setPage("group-details")}
            className={styles.menuItem}
          >
            <img className={styles.icon} src={groupLogo} alt="Stellar" />
            <span className={styles.subheader}>
              <Trans id="menu.group">Group</Trans>
            </span>
          </span>
        </ListGroupItem>
        <ListGroupItem>
          <span
            onClick={() => props.setPage("group-meetingsMenu")}
            className={styles.menuItem}
          >
            <img className={styles.icon} src={meetingLogo} alt="Stellar" />
            <span className={styles.subheader}>
              <Trans id="meetings">Meetings</Trans>
            </span>
          </span>
        </ListGroupItem>
        <ListGroupItem>
          <span
            onClick={() => props.setPage("group-learningPage")}
            className={styles.menuItem}
          >
            <img className={styles.icon} src={schoolLogo} alt="Stellar" />
            <span className={styles.subheader}>
              <Trans id="learningContent.title">Learning</Trans>
            </span>
          </span>
        </ListGroupItem>
      </ListGroup>
    </Container>
  )
}

VslaMenu.propTypes = {
  setPage: PropTypes.func,
}

const mapStateToProps = () => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return { setPage: (page) => dispatch(setCurrentPage(page)) }
}

export default connect(mapStateToProps, mapDispatchToProps)(VslaMenu)
